"use strict";

var _interopRequireDefault = require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getUserCoin = getUserCoin;
exports.updateUserCoin = updateUserCoin;
var _request = _interopRequireDefault(require("@/utils/request"));
function getUserCoin(token, uuid, isSummary) {
  const headers = {
    'Authorization': 'Bearer ' + token
  };
  return (0, _request.default)({
    url: `/user-coins/${uuid}?isSummary=${isSummary}`,
    baseURL: process.env.VUE_APP_BASE_API,
    method: 'get',
    headers
  });
}
function updateUserCoin(token, uuid, tx) {
  const headers = {
    'Authorization': 'Bearer ' + token
  };
  return (0, _request.default)({
    url: `/user-coins/${uuid}`,
    baseURL: process.env.VUE_APP_BASE_API,
    method: 'patch',
    headers,
    data: tx
  });
}